import React from 'react';

/**
 * Компонент секции основных параметров кредита
 */
const LoanParametersSection = ({ formData, handleInputChange, errors }) => {
  return (
    <fieldset className="mb-8 border-b border-gray-200 dark:border-gray-700 pb-8">
      <legend className="text-xl font-medium text-gray-800 dark:text-gray-200 mb-5">Основные параметры</legend>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-5">
        {/* Стоимость недвижимости */}
        <div>
          <label htmlFor="propertyPrice" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1.5">
            Стоимость недвижимости
          </label>
          <div className="relative rounded-md shadow-sm">
            <input
              type="text" id="propertyPrice" name="propertyPrice" inputMode="decimal"
              value={formData.propertyPrice} onChange={handleInputChange}
              className={`form-input pl-4 pr-10 ${errors.propertyPrice ? 'input-error' : ''}`}
              placeholder="6 000 000" required
              aria-invalid={!!errors.propertyPrice}
              aria-describedby="propertyPrice-error"
            />
            <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
              <span className="text-gray-500 dark:text-gray-400 sm:text-sm">₽</span>
            </div>
          </div>
          {errors.propertyPrice && (
            <p id="propertyPrice-error" className="mt-1 text-xs text-red-600 dark:text-red-400" role="alert">
              {errors.propertyPrice}
            </p>
          )}
        </div>

        {/* Первоначальный взнос */}
        <div>
          <label htmlFor="initialPayment" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1.5">
            Первоначальный взнос
          </label>
          <div className="relative rounded-md shadow-sm">
            <input
              type="text" id="initialPayment" name="initialPayment" inputMode="decimal"
              value={formData.initialPayment} onChange={handleInputChange}
              className={`form-input pl-4 pr-10 ${errors.initialPayment ? 'input-error' : ''}`}
              placeholder="1 500 000" required
              aria-invalid={!!errors.initialPayment}
              aria-describedby="initialPayment-error initialPayment-hint"
            />
            <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
              <span className="text-gray-500 dark:text-gray-400 sm:text-sm">₽</span>
            </div>
          </div>
          {errors.initialPayment && (
            <p id="initialPayment-error" className="mt-1 text-xs text-red-600 dark:text-red-400" role="alert">
              {errors.initialPayment}
            </p>
          )}
          <p id="initialPayment-hint" className="mt-1 text-xs text-gray-500 dark:text-gray-400">
            ({calculatePercent(formData.initialPayment, formData.propertyPrice)}% от стоимости)
          </p>
        </div>

        {/* Срок кредита */}
        <div>
          <label htmlFor="loanTerm" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1.5">
            Срок ипотеки
          </label>
          <div className="relative rounded-md shadow-sm">
            <input
              type="text" id="loanTerm" name="loanTerm" inputMode="decimal"
              value={formData.loanTerm} onChange={handleInputChange}
              className={`form-input pl-4 pr-12 ${errors.loanTerm ? 'input-error' : ''}`}
              placeholder="20" required
              aria-invalid={!!errors.loanTerm}
              aria-describedby="loanTerm-error"
            />
            <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
              <span className="text-gray-500 dark:text-gray-400 sm:text-sm">лет</span>
            </div>
          </div>
          {errors.loanTerm && (
            <p id="loanTerm-error" className="mt-1 text-xs text-red-600 dark:text-red-400" role="alert">
              {errors.loanTerm}
            </p>
          )}
        </div>

        {/* Процентная ставка */}
        <div>
          <label htmlFor="interestRate" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1.5">
            Процентная ставка
          </label>
          <div className="relative rounded-md shadow-sm">
            <input
              type="text" id="interestRate" name="interestRate" inputMode="decimal"
              value={formData.interestRate} onChange={handleInputChange}
              className={`form-input pl-4 pr-10 ${errors.interestRate ? 'input-error' : ''}`}
              placeholder="7.5" required
              aria-invalid={!!errors.interestRate}
              aria-describedby="interestRate-error"
            />
            <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
              <span className="text-gray-500 dark:text-gray-400 sm:text-sm">%</span>
            </div>
          </div>
          {errors.interestRate && (
            <p id="interestRate-error" className="mt-1 text-xs text-red-600 dark:text-red-400" role="alert">
              {errors.interestRate}
            </p>
          )}
        </div>
      </div>
    </fieldset>
  );
};

// Вспомогательная функция для расчета процента
const calculatePercent = (part, whole) => {
  const partNum = parseFloat(part) || 0;
  const wholeNum = parseFloat(whole) || 1;
  if (wholeNum <= 0) return '0';
  return (partNum / wholeNum * 100).toFixed(1);
};

export default LoanParametersSection;